import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id AFF98802-E02B-4EC8-8AFF-F0F5373D86C5
 * name headset
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/headset.svg
 * tags
 * - Audio 
 * - Device / Tech 
 */
export const HeadsetIcon = createSvgIcon(<><path d="M12,1C7,1 3,5 3,10V17A3,3 0 0,0 6,20H9V12H5V10A7,7 0 0,1 12,3A7,7 0 0,1 19,10V12H15V20H19V21H12V23H18A3,3 0 0,0 21,20V10C21,5 16.97,1 12,1Z" /></>, 'HeadsetIcon');
export default HeadsetIcon